import $ from "../../libs/jquery-3.3.1.min.js"
import {AudioPlaylist} from '/js/app/base/AudioPlaylist.js'
import {gsap} from "../../libs/gsap/all.js"
import {Howl} from "howler";

export class Helper {

  // Constructor
  constructor() {
    this.disabled = true;

    // Animation timeline
    this.currentTimeline = null;

    this.helperShown = false;
    this.helperConfirmationShown = false;
  }

  initHelper() {
    // Check if helper exist
    this.disabled = $("#helper").length <= 0;
  }

  /**
   * Show helper CTA
   */
  enable() {
    if (!this.disabled && !this.helperShown) {
      this.helperShown = true;
      $("#helper #helper-button-container").addClass("shown");
    }
  }

  /**
   * Hide helper CTA
   */
  disable() {
    if (!this.disabled && this.helperShown) {
      $("#helper #helper-button-container").removeClass("shown");
      this.helperShown = false;
    }
  }

  /**
   * Show helper confirmation
   */
  showHelperConfirmation() {
    if (!this.helperConfirmationShown) {
      this.helperConfirmationShown = true;

      // reset timeline
      this.killTimeline();

      // Build animation timeline
      this.currentTimeline = gsap.timeline();
      this.currentTimeline.add(() => {
        $("#helper-overlay").addClass("shown");
        gsap.set("#helper-step1", {alpha: 1.0});
        gsap.set("#helper-step2", {alpha: 0.0});
      }, 0.0);
      this.currentTimeline.to("#helper-overlay", {alpha: 1.0, duration: 1.1, ease: "power1.inOut"}, 0.0);
      this.currentTimeline.to("#helper-phone", {y: -986, duration: 1.1, ease: "power1.inOut"}, 0.0);
      this.currentTimeline.add(() => {
        $("#helper-confirmation, #helper-step1").addClass("shown");
      });
    }
  }

  /**
   * Hide helper confirmation
   */
  hideHelperConfirmation() {
    if (this.helperConfirmationShown) {
      this.helperConfirmationShown = false;

      // reset timeline
      this.killTimeline();

      // Build animation timeline
      this.currentTimeline = gsap.timeline();
      this.currentTimeline.add(() => {
        $("#helper-confirmation, #helper-step1, #helper-step2").removeClass("shown");
      }, 0.0);
      this.currentTimeline.to("#helper-phone", {y: 0, duration: 1.1, ease: "power1.inOut"}, 0.0);
      this.currentTimeline.to("#helper-overlay", {alpha: 0.0, duration: 1.1, ease: "power1.inOut"}, 0.0);
      this.currentTimeline.add(() => {
        $("#helper-overlay").removeClass("shown");
      });
    }
  }

  /**
   * Go to next step and show textos
   */
  showTextos() {
    if (this.helperConfirmationShown) {
      // Build animation timeline
      this.killTimeline();
      this.currentTimeline = gsap.timeline();

      this.currentTimeline.add(() => {
        $("#helper #helper-step1").removeClass("shown");
      });
      this.currentTimeline.to("#helper #helper-step1", {alpha: 0.0, duration: 0.5, ease: "power1.inOut"}, '<=');
      this.currentTimeline.to("#helper #helper-step2", {alpha: 1.0, duration: 0.5, ease: "power1.inOut"}, '<=');
      this.currentTimeline.fromTo(["#helper-textos .helper-message-box", "#helper-textos .helper-image-box"],
        {scale: 0.0},
        {scale: 1.0, stagger: {each: 0.60}, ease: "power1.inOut"},
      );
      this.currentTimeline.add(() => {
        $("#helper #helper-step2").addClass("shown");
      }, '<=');
    }
  }

  /**
   * Kill/reset timeline before building a new one
   */
  killTimeline() {
    if (this.currentTimeline) {
      this.currentTimeline.kill();
      this.currentTimeline = null;
    }
  }

  /**
   * Reset function
   */
  reset() {
    this.disable();
  }

}
